import React from "react";
import { Icon } from "./Icon";

interface Instagram32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Instagram32: React.FC<Instagram32Props> = ({
  size,
  className,
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M707.2 124.8h-390.4c-105.6 0-192 86.4-192 192v390.4c0 105.6 86.4 192 192 192h390.4c105.6 0 192-86.4 192-192v-390.4c0-105.6-86.4-192-192-192zM835.2 707.2c0 70.4-57.6 128-128 128h-390.4c-70.4 0-128-57.6-128-128v-390.4c0-70.4 57.6-128 128-128h390.4c70.4 0 128 57.6 128 128v390.4z" />
      <path d="M512 304c-115.2 0-208 92.8-208 208s92.8 208 208 208c115.2 0 208-92.8 208-208s-92.8-208-208-208zM512 652.8c-80 0-144-64-144-144s64-144 144-144 144 64 144 144-64 144-144 144z" />
      <path d="M768 300.8c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z" />
    </Icon>
  );
};
